import React, { useEffect, useRef, useState } from "react";
import { isVerified } from "../../../../../../utils/Helper";
import { Card, Input, Select, Button } from "../../../../../common";
import { geoNames } from "../../../../../../utils/countriesGeonames";
// import { countryCodes } from "../../../profile/countryCodes";
import { extractCountryCodeAndPhoneCode } from "../../../../../../utils/countriesState";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import {
  useAuthorizedSignMutation,
  useAuthorizedSignDraftMutation,
  useCreateAuthorizedSignMutation,
  useUpdateAuthorizedSignMutation,
  useUpdateAuthorizedSignDraftMutation
} from "../../../../../../store/Company/companyApiSlice";
import { useSelector } from "react-redux";
import useCompanyUpdate from "../useCompanyFollowUpdate"
import PhoneNumberInput from "../../../../../common/PhoneNumberInput";
import { DESIGNATION_MAX_LENGTH, validateDesignation } from "../../../../../../utils/designation";

export const AddAuthorizedSignFrom = ({ editAuthorized, modalHandle, refetch, compRefetch, dataChanged, setDataChanged }) => {
  const nameRef = useRef();
  const designationRef = useRef();
  const emailRef = useRef();
  // const mobileRef = useRef();
  const nationalityRef = useRef();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryCodes, setCountryCodes] = useState(extractCountryCodeAndPhoneCode());
  const [countryCode, setCountryCode] = useState("+971");
  const [mobile, setMobile] = useState("");
  const [nameError, setNameError] = useState("");
  const [designationError, setDesignationError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [nationalityError, setNationalityError] = useState("");


  const [authorizedSignCreate, { isLoading }] = useAuthorizedSignMutation();
  const [authorizedSignCreateDraft, { isLoadingDraft }] = useAuthorizedSignDraftMutation();
  const [createAuthorizedSignConnection] = useCreateAuthorizedSignMutation();
  const [updateAuthorizedSign, { isLoading: isUpdating }] =
    useUpdateAuthorizedSignMutation();

  const [updateAuthorizedSignDraft, { isLoading: isUpdatingDraft }] =
    useUpdateAuthorizedSignDraftMutation();

  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const { authorizedSignatory } = useSelector((state) => state.company);

  const handleUpdateCompany = useCompanyUpdate();

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  useEffect(() => {
    if (editAuthorized) {
      nameRef.current.value = editAuthorized?.name || "";
      designationRef.current.value = editAuthorized?.designation || "";
      emailRef.current.value = editAuthorized?.work_email || "";
      setSelectedCountry(editAuthorized?.nationality || "");
      setMobile(editAuthorized?.work_mobile || "");
      setCountryCode(editAuthorized?.work_mobile?.split("|")[0] || "+971");
    }
  }, [editAuthorized]);



  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (nameRef.current.value.trim() === "") {
      newErrors.name = "Full Name is required.";
    }

    const designationMessage = validateDesignation(designationRef.current.value);
    if (designationMessage) {
      newErrors.designation = designationMessage;
    }

    if (emailRef.current.value.trim() === "") {
      newErrors.email = "Email Address is required.";
    } else if (!isValidEmail(emailRef.current.value.trim())) {
      newErrors.email = "Invalid Email Address.";
    }

    if (mobile.trim() === "") {
      newErrors.phone = "Phone Number is required.";
    }
    if (selectedCountry.trim() === "") {
      newErrors.nationality = "Nationality is required.";
    }
    setNameError(newErrors.name || "");
    setDesignationError(newErrors.designation || "");
    setEmailError(newErrors.email || "");
    setPhoneError(newErrors.phone || "");
    setNationalityError(newErrors.nationality || "");
    if (Object.keys(newErrors).length > 0) {
      return;
    }
    let work_mobile = mobile;
    const verifiedData = currentEditingCompany.verifiedCompany;
    if (isVerified(verifiedData)) {
      if (editAuthorized) {
        try {
          if (editAuthorized?.authorized_sign_draftID) {
            if (editAuthorized?.authorized_signID_id != undefined && editAuthorized?.authorized_signID_id != null) {
              const res = await updateAuthorizedSignDraft({
                authorized_signID: editAuthorized?.authorized_sign_draftID,
                data: {
                  authorized_signID: editAuthorized?.authorized_signID_id,
                  current_companyID: currentEditingCompany?.companyID,
                  name: nameRef.current.value,
                  designation: designationRef.current.value,
                  work_email: emailRef.current.value,
                  work_mobile,
                  nationality: selectedCountry,
                  request_type: 'Authorized Signatory update request'
                },
                token,
              }).unwrap();
              if (res) {
                refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
              }
            } else {
              const res = await updateAuthorizedSignDraft({
                authorized_signID: editAuthorized?.authorized_sign_draftID,
                data: {
                  current_companyID: currentEditingCompany?.companyID,
                  name: nameRef.current.value,
                  designation: designationRef.current.value,
                  work_email: emailRef.current.value,
                  work_mobile,
                  nationality: selectedCountry,
                  request_type: 'Authorized Signatory update request'
                },
                token,
              }).unwrap();
              if (res) {
                refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
              }
            }

          } else {
            const res = await authorizedSignCreateDraft({
              data: {
                authorized_signID: editAuthorized?.authorized_signID,
                current_companyID: currentEditingCompany?.companyID,
                name: nameRef.current.value,
                designation: designationRef.current.value,
                work_email: emailRef.current.value,
                work_mobile,
                nationality: selectedCountry,
                request_type: 'Authorized Signatory create request'
              },
              token,
            }).unwrap();
            if (res) {
              refetch();
              compRefetch();
              setDataChanged(!dataChanged);
              modalHandle();
            }
          }
        } catch (error) {
        } finally {
          modalHandle();
        }
      } else {
        try {
          const res = await authorizedSignCreateDraft({
            data: {
              authorized_signID: editAuthorized?.authorized_signID,
              current_companyID: currentEditingCompany?.companyID,
              name: nameRef.current.value,
              designation: designationRef.current.value,
              work_email: emailRef.current.value,
              work_mobile,
              nationality: selectedCountry,
              request_type: 'Authorized Signatory create request'
            },
            token,
          }).unwrap();
          if (res) {
            refetch();
            compRefetch();
            setDataChanged(!dataChanged);
            modalHandle();
          }

        } catch (error) {
        } finally {
          modalHandle();
        }
      }

    }
    else {
      if (editAuthorized) {
        try {
          const res = await updateAuthorizedSign({
            token,
            authorized_signID: editAuthorized?.authorized_signID,
            data: {
              name: nameRef.current.value,
              designation: designationRef.current.value,
              work_email: emailRef.current.value,
              work_mobile,
              nationality: selectedCountry,
            },
          });

          const result = await handleUpdateCompany(currentEditingCompany.companyID, "Authorized Signatory Updated", token);
          if (!result.success) {
            console.error(result.error);
          }
          if (result) {
            refetch();
            compRefetch();
            setDataChanged(!dataChanged);
            modalHandle();
          }

        } catch (error) {
        } finally {
          modalHandle();
        }
      } else {
        try {
          const res = await authorizedSignCreate({
            data: {
              name: nameRef.current.value,
              designation: designationRef.current.value,
              work_email: emailRef.current.value,
              work_mobile,
              nationality: selectedCountry,
            },
            token,
          }).unwrap();

          if (res) {
            const companyAuthSinged = await createAuthorizedSignConnection({
              data: {
                Authorized_signID: res?.authorized_signID,
                companyID: currentEditingCompany?.companyID,
              },
              token,
            }).unwrap();

            if (companyAuthSinged) {
              const result = await handleUpdateCompany(currentEditingCompany.companyID, "New Authorized Signatory Added", token);
              if (result) {
                refetch();
                compRefetch();
                setDataChanged(!dataChanged);
                modalHandle();
              }
              if (!result.success) {
                console.error(result.error);
              }
            }
          }
        } catch (error) {

        } finally {
          modalHandle();
        }
      }
    }
  };

  return (
    <Card classes="rounded bg-white p-4 w-[34rem]">
      <h5 className="text-f18 text-secondarytwo text-left mb-4">
        Add Authorized Signatory
      </h5>

      <div className="text-left">
        <Input
          label="Full Name "
          id="name"
          inputRef={nameRef}
          error={nameError}
          placeholder="Enter"
        />
        <Input
          label="Designation"
          id="designation"
          inputRef={designationRef}
          error={designationError}
          maxLength={DESIGNATION_MAX_LENGTH}
          placeholder="Enter"
        />
        <Input
          label="Work Email"
          id="email"
          inputRef={emailRef}
          error={emailError}
          placeholder="Enter"
        />
        <label className="text-primary text-f14 font-semibold text-left">
          Work Phone
        </label>
        <div className="relative w-full mb-4">
          <PhoneNumberInput
            id="mobile"
            phone={mobile}
            border={true}
            setPhone={setMobile}
            verifyPhoneNumber={false}
            classes={'addBackground'}
            error={phoneError} />
        </div>
        <Select
          label="Nationality"
          id="nationality"
          value={selectedCountry}
          error={nationalityError}
          placeholder="Select a nationality"
          onChange={handleCountryChange}
        >
          <option value="">Select a country</option>
          {geoNames?.map((country) => (
            <option key={country.countryName} value={country.countryCode}>
              {country.countryName}
            </option>
          ))}
        </Select>

        <Button
          onClick={handleSubmit}
          classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 flex items-center justify-center"
        >
          {isLoading || isUpdating || isUpdatingDraft || isLoadingDraft ? <Spinner /> : "Submit"}
        </Button>
      </div>
    </Card>
  );
};

const isValidEmail = (email) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};